/**
 * Единица к одному виду — для сравнения, не для показа.
 *
 * «М.П.» и «м.п.», «шт» и «шт.», лишний пробел — всё это одна единица, и
 * там, где строки сравниваются (объединение блоков ассистентом, дозаполнение
 * цен из зерна) или ищется наценка по единице, они обязаны совпасть.
 * Показываем по-прежнему как написано.
 *
 * Живёт в ядре, а не в обвязке: наценка на закупку (`defaultMarkupRate`)
 * ищет ключ политики по единице, и «шт.» из промпта разбора не должна
 * получать наценку «по умолчанию» вместо наценки на штуки.
 */
export function normalizeUnit(unit: string | undefined): string {
  return (unit ?? "")
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/\s+/g, " ")
    .replace(/\.+$/, "");
}
